import React, { useEffect, useState } from "react";
import * as xlsx from "xlsx";
import Sidebar from "./Sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import { useExcelUpload } from "../hooks/useExcelUpload";
//needs to be converted to props. First will be removed second shall be remain.
import { fieldNameValues } from "../utils/excelUploadColumnDetails";
//Get all the submit functions
import { pricesHandleSubmit } from "../utils/excelUploadSubmitFunctions.js/prices.submit";
import { intentionHandleSubmit } from "../utils/excelUploadSubmitFunctions.js/intention.submit";
import { sowingHandleSubmit } from "../utils/excelUploadSubmitFunctions.js/sowing.submit";
import { cropConditionHandleSubmit } from "../utils/excelUploadSubmitFunctions.js/crop_condition.submit";
import { lintCottonSubmit } from "../utils/excelUploadSubmitFunctions.js/lintCotton.submit";
import { sugarMillSubmit } from "../utils/excelUploadSubmitFunctions.js/sugarMill.submit";

export default function ExcelData() {
  const { state } = useLocation();
  const [inSubmission, setInSubmission] = useState(false);
  const {
    fieldDetails,
    handleSubmitFunctionName,
    url,
    navigateUrl,
    title,
    sheetName,
  } = state;
  let handleSubmitFunction;
  switch (handleSubmitFunctionName) {
    case "prices":
      handleSubmitFunction = pricesHandleSubmit;
      break;
    case "intention":
      handleSubmitFunction = intentionHandleSubmit;
      break;
    case "sowing":
      handleSubmitFunction = sowingHandleSubmit;
      break;
    case "cropCondition":
      handleSubmitFunction = cropConditionHandleSubmit;
      break;
    case "lint_cotton":
      handleSubmitFunction = lintCottonSubmit;
      break;
    case "sugar_mill":
      handleSubmitFunction = sugarMillSubmit;
      break;
    default:
      console.error(`No matching function for ${handleSubmitFunctionName}`);
  }

  //Custom hook
  const { items, setPermanentStore, setRowStart, setRowEnd } = useExcelUpload();

  const navigate = useNavigate();
  const readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = event.target.result;
        try {
          const workbook = xlsx.read(data, { type: "array" });
          const worksheet = workbook.Sheets[sheetName];
          const json = xlsx.utils.sheet_to_json(worksheet);

          const selectedRows = json.map((row) => {
            const cleanedRow = {};

            // Define the fields you want to include in the output
            const fieldsToInclude = fieldNameValues(fieldDetails);

            // Iterate through the fields and include them if they have a value
            for (const field of fieldsToInclude) {
              if (row[field] !== undefined) {
                if (field === "date") {
                  if (!isNaN(row[field])) {
                    const excelStartDate = new Date(1900, 0, 1);

                    // Adjust because Excel has a bug (it treats 1900 as a leap year)
                    const jsDate = new Date(
                      excelStartDate.setDate(
                        excelStartDate.getDate() + row[field] - 1
                      )
                    );

                    cleanedRow[field] = String(jsDate.toISOString()).split(
                      "T"
                    )[0];
                  } else {
                    cleanedRow[field] = String(
                      new Date(row.date).toISOString()
                    ).split("T")[0];
                  }
                } else {
                  cleanedRow[field] = String(row[field]);
                }
              }
            }
            // console.log("My func", cleanedRow);
            return cleanedRow;
            // })
          });

          //Is being set once only when the file is loaded.
          setPermanentStore(selectedRows);
        } catch (error) {
          console.error("Error processing file:", error);
        }
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    //Accomodate all the functions that may have to dynamically modify the function
    let uploadItems;
    if (handleSubmitFunctionName === "sowing") {
      uploadItems = await handleSubmitFunction(items);
    } else {
      uploadItems = handleSubmitFunction(items);
      // console.log("Here are the uplaod items", uploadItems);
    }

    if (!Array.isArray(uploadItems)) {
      alert(
        `Issue with the data. Please try and fix it before submitting. ${uploadItems.message}`
      );
      return;
    }
    const token = sessionStorage.getItem("token");
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(uploadItems),
    })
      .then(() => {
        navigate(navigateUrl);
        localStorage.setItem(
          "rows",
          `${
            uploadItems.length
          } rows were added in ${title.toLowerCase()} using the upload excel feature.`
        );
      })
      .catch((error) => {
        console.error("Error during submission:", error);
      });
  };

  return (
    <>
      <div className="sidebar">
        <Sidebar />
      </div>
      <div id="tabler">
        <form onSubmit={handleSubmit}>
          <h3>{title} File Upload</h3>
          <div className="excel-upload-note">
            <ol>
              <p>
                Both <strong>Start Row</strong> and <strong>End Row</strong> are
                required to select specific rows of the excel sheet.
              </p>
            </ol>
          </div>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <div class="input-group mb-3" style={{ marginRight: "10px" }}>
              <span class="input-group-text" id="inputGroup-sizing-default">
                Start Row
              </span>
              <input
                type="number"
                min={1}
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-default"
                onChange={(e) => setRowStart(e.target.value)}
                required
              />
            </div>

            <div class="input-group mb-3" style={{ marginLeft: "10px" }}>
              <span class="input-group-text" id="inputGroup-sizing-default">
                End Row
              </span>
              <input
                type="number"
                min={1}
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-default"
                onChange={(e) => setRowEnd(e.target.value)}
                required
              />
            </div>
          </div>

          <div class="mb-3">
            <input
              class="form-control"
              type="file"
              id="upload"
              name="upload"
              onChange={readUploadFile}
            />
          </div>

          <br />

          <div className="d-flex flex-column">
            {!inSubmission && (
              <button
                type="button"
                onClick={handleSubmit}
                class="btn submit-btn"
              >
                Submit
              </button>
            )}
            {inSubmission && (
              <button type="button" class="btn submit-btn">
                <div class="spinner-border" role="status">
                  <span class="sr-only"></span>
                </div>
              </button>
            )}
          </div>
        </form>

        <table class="table" id="table1">
          <thead>
            <tr>
              {fieldDetails &&
                fieldDetails
                  .filter((fieldDetail) => fieldDetail.show)
                  .map((fieldDetail, index) => {
                    return (
                      <th scope="col" key={index}>
                        {fieldDetail.fieldName}
                      </th>
                    );
                  })}
            </tr>
          </thead>

          <tbody>
            {items &&
              items.map((price, index) => (
                <tr key={price._id}>
                  {fieldDetails
                    .filter((fieldDetail) => fieldDetail.show)
                    .map((fieldDetail, fieldIndex) => (
                      <td key={fieldIndex}>{price[fieldDetail.fieldName]}</td>
                    ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

// const excelStartDate = new Date(1900, 0, 1);

//                   // Adjust because Excel has a bug (it treats 1900 as a leap year)
//                   const jsDate = new Date(
//                     excelStartDate.setDate(
//                       excelStartDate.getDate() + row[field] - 2
//                     )
//                   );

//                  // console.log(jsDate.toISOString()); // Outputs the JavaScript date in ISO format

//                   //hello
//                   cleanedRow[field] = String(
//                     new Date(row.date).toISOString()
//                   ).split("T")[0];
